// extracted by mini-css-extract-plugin
export var fileInputDropZoneIcon = "file-input__drop-zone-icon_jJVN_k7OEVAonPViXyL5";
export var fileInputDropzone = "file-input__dropzone_rHl3rumwrByyafMtXwNw";
export var fileInputDropzoneNonActive = "file-input__dropzone_non-active_Rk1T2lp5JPoNxxFTkla2";